import React from 'react';
import IconArrowRight from 'venuescanner-js/react/components/Objects/Icons/IconArrowRight';
import IconTree from 'venuescanner-js/react/components/Objects/Icons/IconTree';
import './PlantATree.scss';

export function PlantATree({ isMobileDevice, venue }) {
  return isMobileDevice ? (
    <div className='plant-a-tree'>
      <div className='plant-a-tree__container'>
        <div className='plant-a-tree__tree-emoji'>🌳</div>
        <p>
          We plant a tree for every event booking!{' '}
          <a
            target='_blank'
            rel='noopener noreferrer'
            href='https://intercom.help/venuescannercom/en/articles/5997925-planting-a-tree-for-every-event-booking'>
            Find out more...
          </a>
        </p>
      </div>
      <div className='plant-a-tree__arrow'>
        <a
          target='_blank'
          rel='noopener noreferrer'
          href='https://intercom.help/venuescannercom/en/articles/5997925-planting-a-tree-for-every-event-booking'>
          <IconArrowRight />
        </a>
      </div>
    </div>
  ) : (
    <div className='plant-a-tree'>
      <div className='plant-a-tree__tree-emoji'>🌳</div>
      <p>
        We plant a tree for every event booking!{' '}
        <a
          target='_blank'
          rel='noopener noreferrer'
          href='https://intercom.help/venuescannercom/en/articles/5997925-planting-a-tree-for-every-event-booking'>
          Find out more...
        </a>
      </p>
    </div>
  );
}
